import { makeStyles } from '@material-ui/core'

const styles = (isCompact, isMobile, isFixed) =>
  makeStyles((theme) => {
    const floatingMaxWidth = isMobile ? 420 : isCompact ? 500 : 700

    return {
      paperContainer: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        maxWidth: isFixed ? 'none' : floatingMaxWidth,
        width: '100%',
        padding: theme.spacing(1.5),
        gap: theme.spacing(1.5),
        maxHeight: '100%',
        border: 'none',
        borderRadius: 12,
        boxShadow: '0 16px 40px rgba(15, 23, 42, 0.18)',
      },
      textBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
        minHeight: 0,
      },
      buttonsContainer: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: isMobile ? 'stretch' : 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
      },
    }
  })

export default styles
